import { create } from "zustand";
export const useResourceStore = create((set) => ({
    resources: {
        api: {},
        config: {},
        events: {},
        dispatcher: () => {
            // Null implementation
        },
        tracker: {},
        dispatch: () => {
            // Null implementation
        }
    },
    setResources: (resources) => set({ resources })
}));
//# sourceMappingURL=resource-store.js.map